import React from 'react';
import ClientDashboard from '../components/ClientDashboard';

const DashboardPage = () => {
  return <ClientDashboard />;
};

export default DashboardPage;
